export default "__VITE_ASSET__CoXF$aCm__"